import hf from '../../utils/utils'

const state = {
  token: {},
  SESSIONID: '',
  currentUserId: '',
  permissions: []
}
const getters = {
  token: state => { return state.token || {} },
  currentUserId: state => {
    let currentUserId = state.currentUserId
    if (!currentUserId) {
      currentUserId = app.$hf.cache.get(app.$constants.CURRENT_USERID)
    }
    return currentUserId
  },
  SESSIONID: state => {
    let sessionId = state.SESSIONID
    if (!sessionId) {
      sessionId = app.$hf.cache.get(app.$constants.SESSION_ID)
    }
    return sessionId
  },
  isAuthenticated: state => {
    if (hf.isEmptyObject(state.token)) {
      return false
    }
    return true
  },
  permissions: state => { return state.permissions || [] }
}
const mutations = {
  set_token (state, token) {
    state.token = token
  },
  set_currentUserId (state, userId) {
    state.currentUserId = userId
  },
  SET_SESSIONID (state, sessionId) {
    app.$hf.cache.pushForMax(app.$constants.SESSION_ID, sessionId)
  },
  set_permissions (state, permissions) {
    state.permissions = permissions
  }
}
const actions = {
  login ({commit}, token) {
    let user = token.user
    commit('set_currentUserId', user.userId)
    commit('set_token', user)
    commit('SET_SESSIONID', token.sessionId)
    commit('set_permissions', user.permissions)
  },
  logout ({commit}) {
    app.$post('security/logout').then(res => {
      commit('set_currentUserId', '')
      commit('set_token', {})
      commit('set_permissions', '')
      app.$hf.cache.clear(app.$constants.CURRENT_USERID)
      app.$hf.cache.clear(app.$constants.SESSION_ID)
      window.location.href = app.$prefix + 'login';
      //app.$bus.$emit(app.$constants.HF_LOGIN_SHOW, {})
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js